import { Check, ChevronDown } from "lucide-react";
import { Button } from "./ui/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { getModelLabel } from "../lib/aiModels";
import { useLanguage } from "../contexts/LanguageContext";

/**
 * Selettore del modello LLM.
 * Spec: docs/ai-program/10-byok-and-mcp-rework.md (ADR-107).
 *
 * Mostrava tier e "costo relativo" accanto a ogni modello, e un lucchetto
 * "modello impostato dall'amministratore": serviva a scoraggiare le scelte
 * costose quando l'inferenza la pagava la piattaforma. Ora la paga il coach
 * con la sua chiave, quindi la scelta e' sua e basta — come in VS Code.
 *
 * La lista arriva dal provider: nessun catalogo da mantenere qui.
 */
export function AIModelPicker({
	model,
	availableModels = [],
	onChange,
	compact = false,
}) {
	const { t } = useLanguage();
	const activeLabel = getModelLabel(model, availableModels);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					variant="outline"
					size="sm"
					className="h-8 rounded-sm border-border bg-secondary text-xs"
					aria-label={`${t("aiModel")}: ${activeLabel}`}
				>
					<span className="max-w-32 truncate">
						{compact ? activeLabel : `${t("aiModel")}: ${activeLabel}`}
					</span>
					<ChevronDown className="ml-1 h-3.5 w-3.5 shrink-0" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="start"
				className="max-h-80 w-64 overflow-y-auto rounded-sm"
			>
				<DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-muted-foreground">
					{t("aiModel")}
				</DropdownMenuLabel>
				<DropdownMenuSeparator />
				{availableModels.length > 0 ? (
					availableModels.map((availableModel) => (
						<DropdownMenuItem
							key={availableModel.id}
							onSelect={() => onChange?.(availableModel.id)}
							className="items-center py-2"
						>
							{availableModel.id === model ? (
								<Check className="text-volt" />
							) : (
								<span className="w-4 shrink-0" />
							)}
							<span className="min-w-0 flex-1 truncate">
								{availableModel.label || availableModel.id}
							</span>
						</DropdownMenuItem>
					))
				) : (
					<DropdownMenuItem disabled>{activeLabel}</DropdownMenuItem>
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
